const Menu = {
  menuBody: document.querySelector('[data-menu]'),
  menuOverlay: document.querySelector('[data-menu-close]'),
  submenuExpand: document.querySelectorAll('[data-menu-expand]'),
  submenuWrapper: document.querySelectorAll('[data-menu-submenu]'),

  open: function () {
    const { menuBody, menuOverlay } = Menu;
    const opens = document.querySelectorAll('[data-menu-open]');

    if (opens.length > 0)
      opens.forEach((open) => {
        open.addEventListener('click', () => {
          opens.forEach((o) => {
            o.classList.add('-active');
          });
          menuBody.classList.add('-active');
          menuOverlay.classList.add('-active');
          document.body.classList.add('-blocked');
        });
      });
  },

  close: function () {
    const { menuBody, menuOverlay, submenuWrapper } = Menu;
    const opens = document.querySelectorAll('[data-menu-open]');
    const closes = document.querySelectorAll('[data-menu-close]');

    if (closes)
      closes.forEach((close) => {
        close.addEventListener('click', () => {
          opens.forEach((o) => {
            o.classList.remove('-active');
          });
          menuBody.classList.remove('-active');
          menuOverlay.classList.remove('-active');
          document.body.classList.remove('-blocked');

          if (submenuWrapper.length > 0)
            setTimeout(() => {
              submenuWrapper.forEach((submenu) => {
                submenu.classList.remove('-active');
              });
            }, 400);
        });
      });
  },

  back: function () {
    const backs = document.querySelectorAll('[data-menu-back]');

    if (backs.length > 0)
      backs.forEach((back) => {
        back.addEventListener('click', () => {
          const current = back.closest('[data-menu-submenu]');
          current.classList.remove('-active');
        });
      });
  },

  submenus: function () {
    const { submenuExpand, submenuWrapper } = Menu;

    if (submenuExpand.length > 0 && submenuWrapper.length > 0)
      submenuExpand.forEach((expand, i) => {
        expand.addEventListener('click', () => {
          submenuWrapper[i].classList.add('-active');
        });
      });
  },

  init: function () {
    this.open();
    this.close();
    this.submenus();
    this.back();
  },
};

export default Menu;
